module.exports = __webpack_public_path__ + "img/1.1a4df42.png";